class ProductPack extends HTMLElement {
  constructor() {
    super();

    this.jeansPackSize = this.querySelector('jean-pack-size');

    this.tripackdiscount = 0;
    this.sixpackdiscount = 0;
    this.igExecuted = false;
    this.unitOriginalPrice = window.predictProduct && window.predictProduct.price ? window.predictProduct.price: 0;
    const firstVariant = document.getElementById("first_variant").value;
    /*
     this.overWriteDiscount(2,9.17,firstVariant, 20);
     this.overWriteDiscount(3, 17.74,firstVariant, 58);*/
     this.mercerAbTest = false;
   window.addEventListener("message", (event) => {
      if (event.data === "ig-ready" && !this.igExecuted) {
        return;
        // if queryParam bundle=pack-3 is present, remove the hidden class to free-under-copy

        if (window.location.search.includes("bundle=pack-3")) {
          document.querySelector('.free-under-copy').classList.remove('hidden');
        }
        
        //this.updateIntelligencePrices();
        this.evaluateIntelligems();
        this.igExecuted = true;
        this.classList.remove("hidden");
      }
    }); 
    setTimeout(() => {
      if (this.classList.contains("hidden")) this.classList.remove("hidden");
    }, 3000);

    this.variants_IDs = [];
    this.totalItems = 0;
    this.sidecart = document.querySelector("side-cart");
    this.atcBtn = document.querySelector(".multiple-add-to-cart");
    this.packSizes = document.querySelectorAll(".pack-size__wrapper input");
    this.available = true;




  } 

  evaluateIntelligems() {
    //alert(" IT IS");

    const firstVariant = document.getElementById("first_variant").value;

    const labels1 = document.querySelector('label[for="pack-1"].pack-size');
    const labels2 = document.querySelector('label[for="pack-2"].pack-size');
    const labels3 = document.querySelector('label[for="pack-3"].pack-size');

    let priceUnit = document.querySelector(
      ".price-item.price-item--regular"
    ).textContent;

    //let priceUnitIntIntelligems = window.igData.price.getPriceByVariantId(firstVariant);

    const testObject = window.igData.user.getTestGroup('62e60964-3dee-450e-a688-2ac6f3883d65');

    if (testObject) {

      let priceUnitIntIntelligems = window.igData.price.getPriceByVariantId(firstVariant);
      this.mercerAbTest = true;
      //document.querySelector(".price-item.price-item--regular").innerHTML = `$${priceUnitIntIntelligems}`;
      const { name, isControl } = testObject;
      
      if (testObject && name.includes('V1')) {
        this.overWriteDiscount(2, 5, firstVariant, null);
        this.overWriteDiscount(3, 10, firstVariant, null);
      } else if (testObject && name.includes('V2')) {
        this.overWriteDiscount(2, 15, firstVariant, null);
        this.overWriteDiscount(3, 20, firstVariant, null);
      } else if (testObject && isControl) {
        //this.overWriteDiscount(2, 9.17, firstVariant, 20);
        //this.overWriteDiscount(3, 17.74, firstVariant, 58);
      }
    } else {
      this.classList.remove("hidden");
    }

  }


  overWriteDiscount = (packSize, discount, firstVariant, usdSave = null) => {
 
    let packsInput = document.querySelector(`#pack-${packSize}`);
    if (packsInput) packsInput.setAttribute('discount', discount);

    let labels = document.querySelector(`label[for="pack-${packSize}"].pack-size`);
    let savingsLabel = labels.querySelector('.savings');

    let priceItem = labels.querySelector(".price");
    let priceFinal = labels.querySelector(".price-final");
    let priceDiscount = labels.querySelector(".price-discount");

    let priceTotal = window.igData.price.getPriceByVariantId(firstVariant) * packSize || ((predictProduct.price / 100) * packSize);
    let priceTotalDiscount = priceTotal - (priceTotal * (discount / 100));
    console.log(window.theme);
    if (savingsLabel && !usdSave) savingsLabel.innerHTML = ` ${window.theme.save_text} ${discount.toFixed(0)}% `;
    if (savingsLabel && usdSave) savingsLabel.innerHTML = ` ${window.theme.save_text} $${usdSave} `;
    if (priceFinal) priceFinal.innerHTML = '$' + priceTotalDiscount.toFixed(2);
    priceDiscount.innerHTML = '$' + priceTotal.toFixed(2);
  }



  updateIntelligencePrices() {
    /**
     * TODO: validate with a global var if this function was called before
     */
    const variantSizes = [...document.querySelectorAll(".variant__size")];
    if (window.igData && window.igData.price) {
      variantSizes.forEach((item) => {
        const intelligencePrice = window.igData.price.getPriceByVariantId(
          item.id
        );

        if (intelligencePrice) {
          item.setAttribute("price", intelligencePrice);
        }
      });
    }
  }
  cleanUrlOnePack() {
    // for for="pack-1"
    const onePack = document.querySelector('label[for="pack-1"].pack-size');
    // on click remove the url query params 
    onePack.addEventListener('click', () => {
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue = urlParams.get('bundle');
      if (paramValue) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    });
  }
  setColorByURL() {
    this.cleanUrlOnePack();
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get("bundle");
    const setParam = urlParams.get("color");
    if (paramValue) {
      this.packSizes.forEach((ps) => {
        console.log(`${paramValue} - ${ps.id}`);
        if (ps.id == paramValue) {
          ps.click();
        }
      });
    }
    console.log("setparam " + setParam);
    if (setParam != null) {
      console.log("color bundle clicked");
      this.querySelector(`#${setParam}`).click();
    }
    console.log(paramValue);
  }

  connectedCallback() {
    console.log(window.bundleVariants);
    let sizes = this.querySelectorAll(".size-variants__wrapper input");
    let unitSizes = document.querySelectorAll(
      'variant-radios fieldset[data-option-name="Size"] input'
    );
    let colorSets = this.querySelectorAll(".color-set__wrapper input");
    this.atcBtn.addEventListener("click", () => {
      this.multipleAddToCart();
    });
    sizes.forEach((size) => {
      size.addEventListener("click", () => {
        this.pickSize();
      });
    });
    unitSizes.forEach((size) => {
      size.addEventListener("click", () => {
        //this.querySelector(`.size-variants__wrapper input[value="${size.value}"]`).checked = true;
        //this.querySelector('.pack-size__wrapper input[value="1"]').click();
      });
    });
    colorSets.forEach((colorSet) => {
      colorSet.addEventListener("click", () => {
        this.pickSize();
      });
    });
    this.packSizes.forEach((pk) => {
      pk.addEventListener("click", () => {
        this.changePackSize();
      });
    });
    this.changePackSize();
    this.pickSize();
  }

  disconnectedCallback() { }

  static get observedAttributes() {
    return [
      /* array of attribute names to monitor for changes */
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // called when one of attributes listed above is modified
  }

  async pickSize() {
    
    this.querySelector(".addtocart-error").style.display = "none";
    this.available = true;
    this.totalItems = 0;
    this.variants_IDs = [];
    let colorHeader = this.querySelector(".color_picker-header p span");
    let color = document.querySelector(".color-set__wrapper input:checked");

    if (this.jeansPackSize && this.jeansPackSize.setSelectedColorSet && color) await this.jeansPackSize.setSelectedColorSet(color);
    let packSize = this.querySelector(".pack-size__wrapper input:checked");
    let opts = document.querySelectorAll(
      ".color-set__wrapper input:checked + label .variant__size"
    );
    let checkedOpt = document.querySelector(
      ".size-variants__wrapper input:checked"
    );
    console.info(checkedOpt);
    /*let notCheckedOpt = document.querySelectorAll('.size-variants__wrapper input');
      if(checkedOpt.disabled) {disc

      }
      notCheckedOpt.forEach((ntc, index) => {
          if(ntc.checked) {
              if(ntc.disabled) {
                  if(notCheckedOpt[index+1].disabled == false) {
                      notCheckedOpt[index+1].click();
                  }
              }
          }
        });*/
    let dummyWrapper = document.querySelector("#dummyPack");
    let grandParent = null;
    if (color) {
      dummyWrapper.value = color.getAttribute("dummy");
      grandParent = color.getAttribute("grand-parent-id");
    }
    if ( grandParent ) {
      this._grandparent_id = color.getAttribute("grand-parent-id");
      this._grand_parent_title = color.getAttribute("grand-parent-title");
    }
    if (checkedOpt) {
      let itemsAdded = true;
      opts.forEach((opt) => {
        if (checkedOpt.value.toLowerCase() == opt.getAttribute("size")) {
          //console.log(color.value);
          //console.log(opt.getAttribute("item-qty"));
          this.variants_IDs.push(opt);
          console.log("opt: ", opt);

          this.va;
          this.totalItems =
            this.totalItems + parseInt(opt.getAttribute("item-qty"));
          if (opt.getAttribute("quantity") < 5) {
            itemsAdded = false;
            this.available = false;
          }
        }
      });

      colorHeader.innerHTML = "";
      if (itemsAdded) {
        console.log(this.totalItems);
        this.atcBtn.classList.remove("disabled-error");
        //this.atcBtn.classList.remove('disabled');
        this.atcBtn.innerHTML = window.theme.add_to_cart;
      } else {
        console.log("here");
        this.atcBtn.classList.add("disabled-error");
        this.atcBtn.innerHTML = window.theme.add_to_cart;
      }
      let activeColors = null;
      if (color && color.nextElementSibling) {
        activeColors =
          color.nextElementSibling.querySelectorAll(".color-set__sizes");
      }
      console.log(activeColors);
      if (activeColors) {
        activeColors.forEach((ac) => {
          if (colorHeader.innerHTML != "") {
            colorHeader.innerHTML += " / ";
          }
          colorHeader.innerHTML += ac.getAttribute("color").replace("-", " ");
        });
        this.querySelector(".size-variants__wrapper").classList.remove(
          "disabled"
        );
        this.querySelector(".msg__error").classList.add("hidden");
        this.changePrice();
      } else {
        colorHeader.innerHTML = "-";
        this.querySelector(".size-variants__wrapper").classList.add("disabled");
        this.querySelector(".msg__error").classList.remove("hidden");
        //this.variants_IDs = [];
        this.atcBtn.classList.add("disabled");
        this.atcBtn.innerHTML = "sold out";
        this.changePrice();
      }
    } else {
      this.atcBtn.classList.remove("disabled");
      let activeColors = null;
      if (color && color.nextElementSibling) {
        activeColors =
          color.nextElementSibling.querySelectorAll(".color-set__sizes");
      }
      colorHeader.innerHTML = "";
      if (activeColors) {
        activeColors.forEach((ac) => {
          if (colorHeader.innerHTML != "") {
            colorHeader.innerHTML += " / ";
          }
          colorHeader.innerHTML += ac.getAttribute("color").replace("-", " ");
        });
        this.querySelector(".size-variants__wrapper").classList.remove(
          "disabled"
        );
        this.querySelector(".msg__error").classList.add("hidden");
        this.changePrice();
      }
      this.atcBtn.innerHTML = window.theme.add_to_cart;
    }
    if (this.querySelector(".size-variants__wrapper input:checked")) {
      if (
        this.querySelector(".size-variants__wrapper input:checked").disabled
      ) {
        this.atcBtn.innerHTML = "Sold out";
        this.atcBtn.classList.add("disabled");
      } else {
        this.atcBtn.innerHTML = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
        this.atcBtn.classList.remove("disabled");
      }
    }
    window.PacksCore.setUrlByColor(color.getAttribute('id'), packSize.value);
    this.createSliderImage();
    this.changePrice();
  }

  async multipleAddToCart() {
    console.log(this.variants_IDs);
    if (
      !this.atcBtn.classList.contains("disabled-error") &&
      this.querySelector(".msg__error").classList.contains("hidden")
    ) {
      this.atcBtn.classList.add("loading");
      let packSize = this.querySelector(".pack-size__wrapper input:checked");
      let dummyProps = "";
      let packDiscount = 0;
      let packPrice = 0;
      let productSize = this.querySelector(
        ".size-variants__wrapper input:checked"
      ).value;
      this.variants_IDs.forEach((VId) => {
        if (dummyProps != "") {
          dummyProps += " / " + VId.getAttribute("color");
        } else {
          dummyProps += VId.getAttribute("color");
        }
        //console.log('intelli price',window.igData.price.getPriceByVariantId(VId.id));
        let subtotal =
          parseInt(VId.getAttribute("price")) *
          parseInt(VId.getAttribute("item-qty"));
        if (window.igData && window.igData.price && parseInt(window.igData.price.getPriceByVariantId(VId.id))) {
          subtotal =
            parseInt(window.igData.price.getPriceByVariantId(VId.id)) *
            parseInt(VId.getAttribute("item-qty"));
        }

        packDiscount += subtotal;
      });
      let originalPrice = packDiscount;
      packPrice = packDiscount;
      packDiscount =
        packDiscount * parseFloat(packSize.getAttribute("discount"));
      packDiscount = packDiscount / 100;
      packPrice = packPrice - packDiscount;
      if (this.available) {
        let bundleIndex = Date.now();
        let all_items = this.sidecart.querySelectorAll(".sidecart__item");
        all_items.forEach((item) => {
          if (item.getAttribute("bundleindex")) {
            bundleIndex++;
          }
        });
        console.log(bundleIndex);
        let updates = {
          items: [],
        };
        let dummyPack = {
          id: this.querySelector("#dummyPack").value,
          quantity: 1,
          properties: {
            dummyPack: true,
            bundle_index: bundleIndex,
            innerItems: dummyProps,
            ogp: `${originalPrice} - ${packPrice}`,
            packSize: packSize.value,
            originalprice: `${originalPrice}`,
            packPrice: packPrice,
            prodSize: `${this.jeansPackSize.defaultSelected.waist}x${this.jeansPackSize.defaultSelected.inseam}`,
          },
        };
        
        this.variants_IDs.forEach((variantID) => {
          let thisDiscount = packSize.getAttribute("discount");
          let thisID = variantID.getAttribute("id");
          let thisQty = variantID.getAttribute("item-qty");
          const price = variantID.getAttribute("price") - (variantID.getAttribute("price") * thisDiscount / 100);
          const discountedPrice = (price % 1 !== 0) ? price.toFixed(2) : price.toFixed(0);
          const originalItemPrice = (variantID.getAttribute("price") / 100) ;
          const discountedItemPrice = originalItemPrice - (originalItemPrice * thisDiscount / 100);
          const packOriginalPrice = (parseInt(packSize.value) * this.unitOriginalPrice) / 100;
          const igPlusDiscount = calculateExtraDiscount(packOriginalPrice, packPrice, parseFloat(thisDiscount));
          
          let obj = {
            id: thisID,
            quantity: parseInt(thisQty),
            properties: {
              _bundle_index: bundleIndex,
              _teepack: true,
              _discount: thisDiscount,
              _parent_id: dummyPack.id,
              _original_price: originalPrice,
              _total_price: packPrice,
              _parent_name: this._grand_parent_title,
              ...(igPlusDiscount > 0 && { _ig_data_v: igPlusDiscount }),
              'Original price': `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(originalItemPrice)}`,
              'Discounted price': `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(discountedItemPrice)}`
            },
          };
          if (this._grandparent_id != null) {
            obj.properties._grandparent_id = this._grandparent_id;
          }
          if(this.mercerAbTest && this.variants_IDs.length == 3) {
            obj.properties._mercer_boxer_gwp = true;
          }
          updates.items.push(obj);
        });
        //updates.items.push(dummyPack);
        console.log(updates);
        const properties = {
          ...fetchConfig("javascript"),
          body: JSON.stringify(updates),
        };
        console.log(properties);
        try {
          const response = await fetch("/cart/add.js", properties);
          const data = await response.json();

          // get the cart data and then render on the side cart
          this.atcBtn.classList.remove("loading");
          
          if (response.ok) {
            this.sidecart.getCart();
            this.sidecart.openCart();
          } else {
            // Send GTM event for HTTP errors
            if (window.AddResponseHandler) {
              window.AddResponseHandler.handleCartAddError(updates, response, data, null, 'bundle_add');
            }
          }
        } catch (err) {
          console.error(err);
          
          // Send GTM event for network/fetch errors
          if (window.AddResponseHandler) {
            window.AddResponseHandler.handleCartAddError(updates, null, null, err, 'bundle_add');
          }
        }
      }
    } else {
      this.querySelector(".addtocart-error").style.display = "block";
    }
  }

  pickFit() {
    let items = document.querySelectorAll(".product-fit__choice");
    let packSize = this.querySelector(".pack-size__list input:checked");
    let wrappers = this.querySelectorAll(".color-set__wrapper");
    let colorHeader = this.querySelector(".color_picker-header p span");
    colorHeader.innerHTML = "-";
    this.querySelector(".size-variants__wrapper").classList.add("disabled");
    this.querySelector(".msg__error").classList.remove("hidden");
    //this.atcBtn.classList.add('disabled');
    if (packSize.value != 1) {
      //packSize.nextElementSibling.querySelector('.price').innerHTML = '-';
    }
    //this.variants_IDs = [];
    //this.atcBtn.classList.add('disabled');
    this.atcBtn.innerHTML = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
    wrappers.forEach((wrapper) => {
      wrapper.classList.add("hidden");
    });
    wrappers.forEach((wrapper) => {
      items.forEach((item) => {
        if (item.classList.contains("fit-active")) {
          if (wrapper.getAttribute("fit") == item.getAttribute("data-fit")) {
            if (wrapper.getAttribute("pack-size") == packSize.value) {
              wrapper.classList.remove("hidden");
              wrapper.querySelector("input").checked = true;
              this.pickSize();
            }
          }
        }
      });
    });
    this.createSliderImage()
    fontResize();
    this.changePrice();
  }

  changePrice() {
    console.log("changePrice called");
    let atc = this.querySelector(".multiple-add-to-cart");
    let packSize = this.querySelector(".pack-size__wrapper input:checked");
    let packDiscount = 0;
    let unitPrice = document.querySelector(".unit__price");
    let packPrice = 0;
    let titlePrice = document.querySelector(".pack-title__price");
    let packEach = document.querySelector(`.convert_each span[data-unit="${packSize.value}"]`);
    let ogPrice = 0;
    console.log(this.variants_IDs);
    
    if (this.variants_IDs.length != 0) {
      
      this.variants_IDs.forEach((VId) => {
        console.log("VId", VId);
        const itemPrice = VId.getAttribute("price") / 100;
        const itemQty = VId.getAttribute("item-qty");
       
        let subtotal =
          parseInt(itemPrice  ) *
          parseInt(itemQty);
        packDiscount += subtotal;
      });
      ogPrice = packDiscount;
      packPrice = packDiscount;
      packDiscount =
        packDiscount * parseFloat(packSize.getAttribute("discount"));
      packDiscount = packDiscount / 100;
      packPrice = packPrice - packDiscount;
    }

    let priceItem = packSize.nextElementSibling;
    console.log('priceItem', priceItem);
    priceItem = priceItem.querySelector(".price");
    if (packSize.value != 1) {
      if (packPrice == 0) {
        //priceItem.innerHTML = `-`;
        atc.innerHTML = window.theme.add_to_cart;
      } else {
        priceItem.innerHTML = `${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(packPrice)} <small>${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(ogPrice)}</small>`;
        //packEach.innerHTML = Math.ceil(Shopify.formatMoneyAmmount(packPrice) / parseInt(packSize.value));
        //atc.innerHTML = 'add to cart';
      }
      unitPrice.classList.add("hidden");
      titlePrice.classList.remove("hidden");
    } else {
      unitPrice.classList.remove("hidden");
      titlePrice.classList.add("hidden");
    }
    const clonedPriceItem = priceItem.cloneNode(true);
    const priceFinal = clonedPriceItem.querySelector('.price-final');
    const priceDiscount = clonedPriceItem.querySelector('.price-discount');

    if (priceFinal && priceDiscount) {
        priceFinal.innerHTML = priceFinal.innerHTML + ` ${window.theme.shop_currency}`;
        priceDiscount.innerHTML = priceDiscount.innerHTML + ` ${window.theme.shop_currency}`;
    } else {
        clonedPriceItem.innerHTML = `${window.theme.cart_currency_symbol} ${packPrice.toFixed(2)} ${window.theme.shop_currency} <small>${window.theme.cart_currency_symbol}${ogPrice} ${window.theme.shop_currency}</small>`;
    }
    titlePrice.innerHTML = clonedPriceItem.innerHTML;
    fontResize();
  }

  changePackSize() {
    let wrapper = document.querySelector(".product-pack__content");
    let unitEls = {
      vr: document.querySelector("variant-radios"),
      vrSW: document.getElementById("variant-radios-single-wrapper"),
      fcp: document.querySelector("fit-color-picker .product-color_picker"),
      pf: document.querySelector(".product-buy-buttons"),
      vrsg: document.querySelector(".variant-radios__size-guide"),
    };
    let checkedOpt = this.querySelector(".pack-size__wrapper input:checked");
    console.log(checkedOpt.value);
    
    if (checkedOpt.value == 3 && this.mercerAbTest) {
      document.querySelector('.free-under-copy').classList.remove('hidden'); 
    }else {
      document.querySelector('.free-under-copy').classList.add('hidden');
    }
    if (checkedOpt.value == 1) {
      wrapper.classList.add("hidden");
      unitEls.vr.classList.remove("hidden");
      unitEls.vrSW.classList.remove("hidden");
      unitEls.fcp.classList.remove("hidden");
      unitEls.pf.classList.remove("hidden");
      unitEls.vrsg.classList.remove("hidden");
      let unitChecked = document.querySelector(
        `variant-radios fieldset[data-option-name="Size"] input:checked`
      );
      if (unitChecked) {
        unitChecked.checked = false;
        unitChecked.click();
      } else {
        let packChecked = this.querySelector(
          ".size-variants__wrapper input:checked"
        );
        if (packChecked) {
          console.log(packChecked.value);
          const selectedWaist = this.jeansPackSize.defaultSelected.waist;
          const selectedInseam = this.jeansPackSize.defaultSelected.inseam;

          if (selectedWaist) document.querySelector(`variant-radios fieldset[data-option-name="Waist"] input[value="${selectedWaist}"]`).click();
          if (selectedInseam) document.querySelector(`variant-radios fieldset[data-option-name="Inseam"] input[value="${selectedInseam}"]`).click();

        }
      }
      if (document.querySelector('.seasonal-colors-container') && document.querySelector('.seasonal-colors-container').innerHTML.trim() !== '') {
        document.querySelector('.seasonal-color_picker')?.classList.remove('hidden');
      }
    } else {

      let unitSize = document.querySelector(
        'variant-radios fieldset[data-option-name="Size"] input:checked'
      );
      let sizes = this.querySelectorAll(".size-variants__wrapper input");
      if (unitSize) {
        unitSize.checked = false;
        sizes.forEach((size) => {
          if (size.value == unitSize.value) {
            size.checked = true;
          }
        });
      }
      wrapper.classList.remove("hidden");
      unitEls.vr.classList.add("hidden");
      unitEls.vrSW.classList.add("hidden");
      unitEls.fcp.classList.add("hidden");
      unitEls.pf.classList.add("hidden");
      unitEls.vrsg.classList.add("hidden");
      this.jeansPackSize.setSelectedPackAndColor(checkedOpt.value);
      document.querySelector('.seasonal-color_picker')?.classList.add('hidden');
    }
    this.pickFit();
  }


  createSliderImage() {
    //return;
    let bundleImg = document.querySelector(
      '.product-images-container .swiper-slide[data-swiper-slide-index="0"] img'
    );
    let bundleImgDup = document.querySelector(
      '.product-images-container .swiper-slide-duplicate[data-swiper-slide-index="0"] img'
    );
    let bundleDot = document.querySelectorAll(
      ".product-images-container .swiper-pagination .swiper-pagination-bullet img"
    );
    let color = document.querySelector(
      ".color-set__wrapper:not(.hidden) input:checked"
    );
    let modalImg = document.querySelector(
      '.product-images_zoomup-container .swiper-wrapper .swiper-slide[data-swiper-slide-index="0"] img'
    );
    let modalImgDup = document.querySelector(
      '.product-images_zoomup-container .swiper-wrapper .swiper-slide-duplicate[data-swiper-slide-index="0"] img'
    );
    let packSize = this.querySelector(".pack-size__list input:checked");
    if (packSize.value != 1) {
      if (color) {
        console.log("bundle");
        bundleImg.src = color.getAttribute("img");
        bundleImgDup.src = color.getAttribute("img");
        modalImg.src = color.getAttribute("img");
        modalImgDup.src = color.getAttribute("img");
        if (window.innerWidth >= 750) {
          bundleDot[0].src = color.getAttribute("img");
        }
        let bullet = document.querySelector(
          ".swiper-pagination .swiper-pagination-bullet"
        );
        bullet.click();
      }
    } else {
      console.log("original");
      bundleImg.src = bundleImg.getAttribute("original");
      bundleImgDup.src = bundleImg.getAttribute("original");
      modalImg.src = bundleImg.getAttribute("original");
      modalImgDup.src = bundleImg.getAttribute("original");
      if (window.innerWidth >= 750) {
        bundleDot[0].src = bundleImg.getAttribute("original");
      }
    }
  }
}

customElements.define("product-pack", ProductPack);